import { Grid, Divider } from "@mui/material";
import { TitledSection } from "components/Classifiers/Common/TitledSection";
import { AnswerColor } from "components/UI/AcxAnswerSelector";
import React, { useState } from "react";
import { ErrorResult } from "./ErrorResult";
import {
    filterBySource,
    hasBothSources,
    ResultSource,
    ResultSourceFilter,
} from "./ResultSourceFilter";
import { TestLLMClassifierAgreementResult } from "models/LLMs/Testing/TestLLMClassifierAgreementResult";
import { ResultBadge } from "../ResultBadge";
import { getFriendlyId } from "../utils";

interface ErrorResultsSectionProps {
    results: TestLLMClassifierAgreementResult[];
}

export function ErrorResultsSection({ results }: ErrorResultsSectionProps) {
    const [source, setSource] = useState<ResultSource>("all");
    if (results.length === 0) return null;

    const shownResults = filterBySource(results, source);

    return (
        <TitledSection
            id={getFriendlyId("errors")}
            title={
                <ResultBadge color={AnswerColor.RED}>
                    Errors ({results.length})
                </ResultBadge>
            }
            action={
                hasBothSources(results) && (
                    <ResultSourceFilter
                        id="errors-source"
                        results={results}
                        value={source}
                        onChange={setSource}
                    />
                )
            }
            variant="bordered"
            collapsible
            sx={(theme) => ({
                borderLeft: `4px solid ${theme.palette.red.main}`,
            })}
        >
            <Grid container direction="column" flexWrap="nowrap" rowGap={2}>
                {shownResults.map((result, number) => (
                    <React.Fragment key={result.conversation.id + number}>
                        <ErrorResult result={result} number={number} />
                        {number !== shownResults.length - 1 && <Divider />}
                    </React.Fragment>
                ))}
            </Grid>
        </TitledSection>
    );
}
